import React from 'react';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import LinkJump from '@gp/components/LinkJump';
import PercentProgress from '../components/PercentProgress';
import {
  getFormatNumPlus,
  getArraySort,
  queryJumpable,
} from '@gp/utils/common';
import { history } from 'umi';
import { MENU_ID_MAP, SLASH_G_POP } from '@gp/constants/const';
import {
  TABLE_HEAD_MAP,
  SEGMENT_GROSS_REVENUE,
  SEGMENT_NET_PROFIT,
  FIXED_BO_ORDER_MAP,
} from '../constants';

const DATE_LIST_MAP: { [keyName: string]: 'grossRevenue' | 'netProfit' } = {
  [SEGMENT_GROSS_REVENUE]: 'grossRevenue',
  [SEGMENT_NET_PROFIT]: 'netProfit',
};

function getTableList(data: any) {
  const resultList = [];
  if (Array.isArray(data) && data?.length) {
    // 排序start
    let allTotalItem: any = null,
      othersItem: any = null,
      fixedSortItems: any = [], // 固定排序的bo
      fixedSortedItems: any = [], // 固定排序的bo排好序后
      needSortItems: any[] = [];
    for (let i = 0; i < data?.length; i++) {
      const t = data?.[i];
      if (t?.management_team?.toLowerCase() === 'portfolio total') {
        allTotalItem = t;
      } else if (t?.management_team?.toLowerCase() === 'others') {
        othersItem = t;
      } else if (
        FIXED_BO_ORDER_MAP?.includes(t?.management_team?.toLowerCase())
      ) {
        fixedSortItems.push(t);
      } else {
        needSortItems.push(t);
      }
    }
    // 固定排序的bo
    for (let i = 0; i < FIXED_BO_ORDER_MAP?.length; i++) {
      const t = FIXED_BO_ORDER_MAP?.[i];
      for (let j = 0; j < fixedSortItems?.length; j++) {
        const k = fixedSortItems?.[j];
        if (t === k?.management_team?.toLowerCase()) {
          fixedSortedItems.push(k);
          break;
        }
      }
    }
    let sortResultList = getArraySort(
      needSortItems,
      'string',
      'asc',
      'management_team',
    );
    if (fixedSortedItems?.length) {
      sortResultList = [...fixedSortedItems, ...sortResultList];
    }
    if (allTotalItem) {
      sortResultList?.unshift(allTotalItem);
    }
    if (othersItem) {
      sortResultList?.push(othersItem);
    }
    // 排序end
    if (Array.isArray(sortResultList)) {
      for (let i = 0; i < sortResultList?.length; i++) {
        const t = sortResultList?.[i];
        const studioMetrics = t?.studio_metrics; // studio_metrics后端排序
        if (Array.isArray(studioMetrics)) {
          for (let j = 0; j < studioMetrics?.length; j++) {
            const k = studioMetrics?.[j];
            const isLast = j === studioMetrics?.length - 1;
            resultList.push({
              uniqueId: k?.studio?.id + j,
              boName: t?.management_team,
              isSpacerBlock: isLast,
              isAllTotal: k?.studio?.name?.toLowerCase() === 'all studios',
              isTotal:
                k?.studio?.name?.toLowerCase() === 'sub-total' ||
                k?.studio?.name?.toLowerCase() === 'all studios',
              studioId: k?.studio?.id,
              studioName: k?.studio?.name,
              studioCover: k?.studio?.cover,
              ytm: k?.ytm,
              nearestYearBudget: k?.budget,
              completion: k?.completion,
              nearestYearForecast: k?.forecast,
              nearestYearActual: k?.last_actual,
            });
          }
        }
      }
    }
  }

  return resultList;
}

const toDetail = (
  studioId: string,
  studioName: string,
  isJump: boolean = true,
) => {
  if (!studioId) return '';
  const filter = encodeURIComponent(
    JSON.stringify({
      studioId,
      studioName,
      menuFrom: MENU_ID_MAP['studio-dashboard_studio-overall'], // 用于标识左侧菜单栏当前选中高亮
      tab: 'finance',
    }),
  );
  const url = SLASH_G_POP + `/Studio/PortfolioOverview/Detail?filter=${filter}`;
  if (isJump) {
    history.push(url);
  }

  return url;
};

// 获取列配置
const getColumns = (
  segmentValue: '1' | '2',
  dateList: {
    grossRevenue: any;
    netProfit: any;
  },
) => {
  const dates = dateList?.[DATE_LIST_MAP?.[segmentValue]];
  const budgetDate = dates?.budget_date?.slice(2, 4) || '-';
  const forecastDate = dates?.forecast_date?.slice(2, 4) || '-';
  const actualDate = dates?.pre_year?.slice(2, 4) || '-';

  return [
    // bo
    {
      key: TABLE_HEAD_MAP?.[segmentValue]?.['bo']?.keyName,
      header: () => {
        const titles = TABLE_HEAD_MAP?.[segmentValue]?.['bo']?.title;

        return (
          <div className="dbg-table-header-text">
            {titles?.[0]}
            <br />
            {titles?.[1]}
          </div>
        );
      },
      align: TABLE_HEAD_MAP?.[segmentValue]?.['bo']?.align,
      width: TABLE_HEAD_MAP?.[segmentValue]?.['bo']?.width,
      render: (cvm: any) => {
        return (
          <>
            <div className="dbg-table-bold">
              {cvm?.isTotal ? cvm?.boName || '-' : ''}
            </div>
          </>
        );
      },
    },
    // studio
    {
      key: TABLE_HEAD_MAP?.[segmentValue]?.['studio']?.keyName,
      header: () => {
        const titles = TABLE_HEAD_MAP?.[segmentValue]?.['studio']?.title;
        return (
          <div className="dbg-table-header-text">
            {titles?.[0]}
            <br />
            {titles?.[1]}
          </div>
        );
      },
      align: TABLE_HEAD_MAP?.[segmentValue]?.['studio']?.align,
      width: TABLE_HEAD_MAP?.[segmentValue]?.['studio']?.width,
      render: (cvm: any) => {
        return (
          <>
            <div className="dbg-table-studio-box">
              {!cvm?.isTotal && (
                <LinkJump url={toDetail(cvm?.studioId, cvm?.studioName, false)}>
                  <GeneralImageNew
                    className="gp-cursor-pointer"
                    // style={{
                    //   border: '1px solid rgba(0, 0, 0, 0.1)',
                    //   marginRight: 10,
                    // }}
                    domain="studio"
                    width={24}
                    height={24}
                    src={cvm?.studioCover}
                    onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
                      if (!queryJumpable(e)) return;
                      toDetail(cvm?.studioId, cvm?.studioName);
                    }}
                  />
                </LinkJump>
              )}
              <LinkJump url={toDetail(cvm?.studioId, cvm?.studioName, false)}>
                <span
                  className={`dbg-table-studio-text ${
                    cvm?.isTotal
                      ? ''
                      : 'dbg-table-studio-name gp-cursor-pointer'
                  }`}
                  title={cvm?.studioName || '-'}
                  onClick={(e) => {
                    if (!queryJumpable(e)) return;
                    toDetail(cvm?.studioId, cvm?.studioName);
                  }}
                >
                  {cvm?.studioName || '-'}
                </span>
              </LinkJump>
            </div>
          </>
        );
      },
    },
    // ytm
    {
      key: TABLE_HEAD_MAP?.[segmentValue]?.['ytm']?.keyName,
      header: () => {
        const titles = TABLE_HEAD_MAP?.[segmentValue]?.['ytm']?.title;
        return (
          <div className="dbg-table-header-text">
            {titles?.[0]?.replace('-', dates?.ytm_date)}
            <br />
            {titles?.[1]}
          </div>
        );
      },
      align: TABLE_HEAD_MAP?.[segmentValue]?.['ytm']?.align,
      width: TABLE_HEAD_MAP?.[segmentValue]?.['ytm']?.width,
      render: (cvm: any) => {
        const v = getFormatNumPlus(cvm?.ytm) || '-';
        return (
          <>
            <>{v}</>
          </>
        );
      },
    },
    // budget
    {
      key: TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-budget']?.keyName,
      header: () => {
        const titles =
          TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-budget']?.title;
        return (
          <div className="dbg-table-header-text">
            {titles?.[0]?.replace('-', budgetDate)}
            <br />
            {titles?.[1]}
          </div>
        );
      },
      align: TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-budget']?.align,
      width: TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-budget']?.width,
      render: (cvm: any) => {
        const v = getFormatNumPlus(cvm?.nearestYearBudget) || '-';
        return (
          <>
            <>{v}</>
          </>
        );
      },
    },
    // completion
    {
      key: TABLE_HEAD_MAP?.[segmentValue]?.['completion-percent']?.keyName,
      header: () => {
        const titles =
          TABLE_HEAD_MAP?.[segmentValue]?.['completion-percent']?.title;
        return (
          <div className="dbg-table-header-text">
            {titles?.[0]}
            <br />
            {titles?.[1]}
          </div>
        );
      },
      align: TABLE_HEAD_MAP?.[segmentValue]?.['completion-percent']?.align,
      width: TABLE_HEAD_MAP?.[segmentValue]?.['completion-percent']?.width,
      render: (cvm: any) => {
        return (
          <>
            <>
              <PercentProgress percent={cvm?.completion || '0'} />
            </>
          </>
        );
      },
    },
    // forecast
    {
      key: TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-forecast']?.keyName,
      header: () => {
        const titles =
          TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-forecast']?.title;
        return (
          <div className="dbg-table-header-text">
            {titles?.[0]?.replace('-', forecastDate)}
            <br />
            {titles?.[1]}
          </div>
        );
      },
      align: TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-forecast']?.align,
      width: TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-forecast']?.width,
      render: (cvm: any) => {
        const v = getFormatNumPlus(cvm?.nearestYearForecast) || '-';
        return (
          <>
            <>{v}</>
          </>
        );
      },
    },
    // actual
    {
      key: TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-actual']?.keyName,
      header: () => {
        const titles =
          TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-actual']?.title;
        return (
          <div className="dbg-table-header-text">
            {titles?.[0]?.replace('-', actualDate)}
            <br />
            {titles?.[1]}
          </div>
        );
      },
      align: TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-actual']?.align,
      width: TABLE_HEAD_MAP?.[segmentValue]?.['nearest-year-actual']?.width,
      render: (cvm: any) => {
        const v = getFormatNumPlus(cvm?.nearestYearActual) || '-';
        return (
          <>
            <>{v}</>
          </>
        );
      },
    },
  ];
};

export { getTableList, getColumns };
